import { render, staticRenderFns } from "./AdsText.vue?vue&type=template&id=1773c938&"
import script from "./AdsText.vue?vue&type=script&lang=js&"
export * from "./AdsText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports